import { useDrag } from 'react-dnd';
import GamePiece from '../../GamePiece';
import { useHexStyles } from '../../../hooks/useHexStyles';
import './GameCarouselItem.css';

function GameCarouselItem(props) {
  const {
    board,
    style,
    pieceStyle,
    hex,
    id,
    onSelect,
    isSelected,
    dragPreviewRef,
    handleOnDrop,
    gridItemProps,
    ...rest
  } = props;
  // console.log('GameCarouselItem :: ...rest', rest);

  /**
   * DRAG CONNECTOR
   */
  const [{ isDragging }, dragRef] = useDrag(
    () => ({
      type: 'piece',
      item: { name: hex.id, data: hex },
      start(item, monitor) {
        console.log('start drag', item, monitor);
        if (item) {
          onSelect(item);
        }
      },
      end(item, monitor) {
        const dropResult = monitor.getDropResult();
        if (item && dropResult) {
          const dropSuccess = item.name === dropResult.name;
          handleOnDrop({
            sourceHex: hex,
            destHex: { id: dropResult.name },
            dropSuccess,
          });
        }
      },
      collect: (monitor) => ({
        isDragging: !!monitor.isDragging(),
      }),
    }),
    [hex],
    dragPreviewRef
  );

  if (pieceStyle) {
    pieceStyle.stroke = '#fff';
    pieceStyle.strokeWidth = 2;
    if (isDragging) {
      pieceStyle.opacity = 0;
      // pieceStyle.flexBasis = 0; // TODO: grid auto and animate to fill empty space
    } else {
      pieceStyle.opacity = 1;
      pieceStyle.transform = isSelected ? 'translate(0, -5px)' : 'initial';
    }
  }

  const hexStyles = useHexStyles({ hex, gridItemProps, board });

  const buttonID = `carouselButton-${hex.q}${hex.r}${hex.s}`;

  return (
    <li
      className={'GameCarouselItem'}
      tabIndex={0}
      style={{ ...style }}
      aria-labelledby={buttonID}
    >
      <button
        id={buttonID}
        name="hex-selected"
        value={`${hex.id}`}
        onClick={(e) => onSelect(e)}
        // onDoubleClick={(e) => onSelect(e)}
        // draggable={!!isDragging}
        // aria-grabbed={!!isDragging}
        aria-hidden={false}
        aria-label={hex.description}
      >
        <span className="GameCarouselItem-Inner" aria-hidden="true">
          <GamePiece
            dragRef={dragRef}
            hex={hex}
            {...rest}
            className={isSelected ? 'selected' : ''}
            handleOnDrop={handleOnDrop}
            style={{
              ...hexStyles,
              ...pieceStyle,
              cursor: 'move',
            }}
          />
        </span>
      </button>
    </li>
  );
}

export default GameCarouselItem;
